/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_alerts_traffic_panel__select_location__label = /** @type {(inputs: {}) => string} */ () => {
	return `Um Meldungen anzuzeigen, geben Sie einen Ort in das Suchfeld ein.`
};

const en_alerts_traffic_panel__select_location__label = /** @type {(inputs: {}) => string} */ () => {
	return `To view alerts, enter a location in the search box.`
};

const es_alerts_traffic_panel__select_location__label = /** @type {(inputs: {}) => string} */ () => {
	return `Para ver alertas, ingrese una ubicación en el cuadro de búsqueda.`
};

const fr_alerts_traffic_panel__select_location__label = /** @type {(inputs: {}) => string} */ () => {
	return `Pour afficher les alertes, saisissez un lieu dans le champ de recherche.`
};

const it_alerts_traffic_panel__select_location__label = /** @type {(inputs: {}) => string} */ () => {
	return `Per visualizzare gli avvisi, inserisci una posizione nella casella di ricerca.`
};

const nl_alerts_traffic_panel__select_location__label = /** @type {(inputs: {}) => string} */ () => {
	return `Om waarschuwingen te bekijken, voert u een locatie in het zoekvak in.`
};

const pt_alerts_traffic_panel__select_location__label = /** @type {(inputs: {}) => string} */ () => {
	return `Para visualizar alertas, insira um local na caixa de pesquisa.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const alerts_traffic_panel__select_location__label = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.alerts_traffic_panel__select_location__label(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("alerts_traffic_panel__select_location__label", locale)
	if (locale === "de") return de_alerts_traffic_panel__select_location__label(inputs)
	if (locale === "en") return en_alerts_traffic_panel__select_location__label(inputs)
	if (locale === "es") return es_alerts_traffic_panel__select_location__label(inputs)
	if (locale === "fr") return fr_alerts_traffic_panel__select_location__label(inputs)
	if (locale === "it") return it_alerts_traffic_panel__select_location__label(inputs)
	if (locale === "nl") return nl_alerts_traffic_panel__select_location__label(inputs)
	return pt_alerts_traffic_panel__select_location__label(inputs)
};